import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { debounce, get } from 'lodash';
import { Form } from 'informed';
import axios from 'axios';
import FormContainer from '../../containers/Form';
import { InputSelect, InputText, InputSelectAsyncCreatable } from '../../components/inputs';
import { API_HOST } from '../../consts';
import { BaseForm } from '../../base';
import Loading from '../../components/Loading';
import { TrackGoogleAnalyticsEvent } from '../../utils/googleAnalytics';
import {
  ClickInfoLearningObject, ClickInfoLearningObjectAction
} from '../../utils/googleAnalytics/events/Itens/EventInfoLearningObject';

class Dados extends BaseForm {
  constructor(props) {
    super(props);
    this.onChangeUselastItemData = this.onChangeUselastItemData.bind(this);
    this.fetchPalavrasChave = this.fetchPalavrasChave.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.callApi = false;
    this.fields = [
      'tipo',
      'exame',
      'bisserial',
      'discriminacao',
      'acertos',
      'pa',
      'pb',
      'pc',
      'instituicao',
      'curso',
      'periodo',
      'componente_curricular',
      'mochila',
      'topico',
      'subtopico',
      'criado_por',
      'dificuldade'
    ];
    this.multiFields = ['areas_conhecimento', 'palavras_chave'];
  }

  state = {
    paramsFetch: {
      codigoId: '',
    },
    tipo: [],
    save: 0,
    metadata: {},
    fetchingData: false,
    formOriginalState: {},
    lastItemData: {},
    usinglastItemData: false,
    dificuldade: [],
    anos: [],
    curso: [],
    avaliacaoPPI: false,
    avaliacaoId: '',
    areaConhecimentoPPI: []
  };

  save = true;

  componentDidMount() {
    this.fetchCurso();
    this.fetchData();
    this.fetchlastItemData();
    this.fetchApi('dificuldade', 'itens');
    // this.fetchApi('tipo', 'itens');
    this.fetchTipo();
    this.fetchApi('exame', 'core');
    this.fetchApi('instituicao', 'core');
    // this.fetchApi('curso', 'core');
    // this.fetchApi('periodo', 'core');
    this.fetchPeriodo();
    this.fetchApi('componente_curricular', 'core');
    this.fetchMetadata();
    this.fetchMe();
    this.fetchAreaConhecimento();



  }

  componentDidUpdate(prevPops, prevState) {

    // Defina os valores presetados nos inputs


    // Adicione a lógica de componentDidUpdate aqui
    if (prevState.paramsFetch !== this.state.paramsFetch) {
      this.fetchPeriodo();
    }
  }

  getPalavrasChave(item) {
    const palavras_chave = get(item, 'palavras_chave');

    if (palavras_chave) {
      return palavras_chave.split(',').map(x => ({ label: x, value: x }));
    }
    else {
      return [];
    }
  }

  fetchPalavrasChave(input, callback) {
    axios.get(`${API_HOST}/itens/palavra_chave`, {
      params: {
        search: input,
      },
    })
      .then((response) => {
        callback(null, {
          options: response.data.results.map(x => ({ value: String(x.id), label: x.descricao })),
        });
      });
  }

  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data });
      })
      .catch((response) => console.log(response.error));
  }

  fetchTipo() {
    axios.get(`${API_HOST}/itens/tipo`)
      .then((response) => {
        const data = response.data.results ? response.data.results : response.data;
        this.handleTipo(data.map(x => ({ value: x.id, label: x['descricao'] })))
      });
  }

  fetchCurso() {
    axios.get(`${API_HOST}/core/curso`)
      .then((response) => {
        const data = response.data;
        this.setState({
          curso: data.map((mapResponse) => ({
            value: mapResponse.id,
            label: mapResponse.descricao,
            codigo: mapResponse.codigo
          }))
        });
      })
  }


  fetchData() {
    console.log('id ', this.id)
    if (this.id !== 'new') {
      this.setState({ fetchingData: true });
      axios.get(`${API_HOST}/itens/item/${this.id}/form`).then((response) => {
        this.setFields(response.data);
        this.setState({
          fetchingData: false,
          criado_por: response.data.criado_por_ids
        });

        const timeoutToUpdateMetadataState = 500;
        setTimeout(() => {
          if (this.formApi.fieldExists('palavras_chave')) {
            this.formApi.setValue('palavras_chave', this.getPalavrasChave(response.data))
          }
        }, timeoutToUpdateMetadataState);

        const exame = get(response, 'data.exame');
        if (exame) {
          this.fetchAreaConhecimento(exame);
        } else {
          this.callApi = true;
        }
      });
    } else {
      this.callApi = true;
    }
  }

  fetchlastItemData() {
    axios
      .get(`${API_HOST}/itens/item/last`)
      .then((response) => {
        this.setState({ lastItemData: response.data });
      })
      .catch((error) => {
        this.setState({ lastItemData: {} });
      });
  }

  fetchMetadata() {
    axios.get(`${API_HOST}/params/param?model=item`).then((response) => {
      this.setState({ metadata: this.mapMetadata(response.data) });
    });
  }

  fetchAreaConhecimento(exame) {
    const params = {
      exames: exame
    };
    axios
      .get(`${API_HOST}/core/area_conhecimento`, { params })
      .then((response) => {
        const data = response.data.results
          ? response.data.results
          : response.data;
        this.setState({
          area_conhecimento: data.map((x) => ({
            value: x.id,
            label: x.descricao
          }))
        });

        const areas_conhecimento =
          get(this.formApi.getState().values, 'areas_conhecimento') || [];
        if (this.formApi.fieldExists('areas_conhecimento')) {
          this.formApi.setValue(
            'areas_conhecimento',
            areas_conhecimento.filter(
              (x) => data.findIndex((y) => x === y.id) !== -1
            )
          );
        }
        this.callApi = true;
      });
  }

  fetchNivel = (e) => {
    this.setState({ isLoading: true })
    axios
      .get(`${API_HOST}/core/periodo/${e.value}/filter_curso`)
      .then((response) => {
        this.setState({
          isLoading: false,
          periodo: response.data.map((x) => ({
            value: x.id,
            label: x.descricao
          }))
        });
      })
  }

  fetchFilterComponenteCurricular = (e) => {
    this.setState({ isLoading: true })
    var areas = ''
    e.map((elements) => (areas += String(elements.value) + ','))
    axios
      .get(`${API_HOST}/core/componente_curricular/${areas}/filter_areas`)
      .then((response) => {
        this.setState({
          isLoading: false,
          componente_curricular: response.data.map((x) => ({
            value: x.id,
            label: x.descricao
          }))
        });
      })
  }

  fetchPeriodo() {
    const { codigoId } = this.state.paramsFetch
    const params = {
      nivel_id: codigoId
    }
    axios.get(`${API_HOST}/core/periodo`, { params })
      .then((response) => {
        const data = response.data
        const anos = []

        data.map((x) => {
          if (x.etapa_nr) {
            anos.push({
              value: x.id,
              label: x.descricao
            })
          }
        })

        this.setState({ anos: anos })
      })
      .catch((response) => console.log(response.error));
  }

  handleTipo(data) {
    const { tipoId } = this.props;

    if (tipoId === '1') {
      this.setState({ tipo: data.filter((item) => [1, 2, 6, 12, 4, 5, 3, 13].includes(item.value)) })
    }
    else if (tipoId === '2') {
      this.setState({ tipo: data.filter((item) => [7, 9, 11, 10].includes(item.value)) })
    }
  }


  onValueChange(values) {
    const data = this.getSubmitData(values);

    if (Array.isArray(data.palavras_chave)) {
      data.palavras_chave = data.palavras_chave.map(x => x.label).join(',');
    } else {
      delete data.palavras_chave;
    }

    if (!this.callApi) {
      return;
    }

    if (this.id === 'new') {
      if (!this.save) {
        return;
      }
      this.setState({ save: this.SALVANDO });
      this.save = false;
      axios
        .post(`${API_HOST}/itens/item`, data)
        .then((response) => {
          const { history, tipoId } = this.props;
          this.id = response.data.id;
          const redirectURL = `/itens/${this.id}/dados?id=${this.state.avaliacaoId}/tipo/${tipoId}`

          history.push(redirectURL);
          this.setState({ save: this.SALVO });
        })
        .catch(() => {
          this.setState({ save: this.ERRO });
        });
    } else {
      console.log(data)
      this.setState({ save: this.SALVANDO });
      axios
        .patch(`${API_HOST}/itens/item/${this.id}`, this.getSubmitData(data))
        .then(() => {
          this.setState({ save: this.SALVO });
        })
        .catch(() => {
          this.setState({ save: this.ERRO });
        });
    }
  }
  onSubmit(url) {
    axios
      .get(`${API_HOST}/itens/item/${this.id}/validate?form=dados`)
      .then(() => {
        const { history } = this.props;
        history.push(`/itens/${this.id}/${url}`);
      })
      .catch((error) => {
        this.onValidateError(error, 'dados');
      });
  }

  onChangeUselastItemData(event) {
    const value = event.target.checked;
    if (value) {
      this.setState({
        formOriginalState: this.formApi.getState().values,
        usinglastItemData: true
      });
      this.formApi.setValues(this.state.lastItemData);
    } else {
      this.setState({
        usinglastItemData: false
      });
      this.formApi.setValues(this.state.formOriginalState);
    }
  }
  getAvaliationPPI = (formApi) => {
    const url = window.location.href;
    const partesDaUrl = url.split("?");
    let id = null;

    if (partesDaUrl.length > 1) {
      const parametros = partesDaUrl[1];
      const paresChaveValor = parametros.split("&");

      for (const par of paresChaveValor) {
        const [chave, valor] = par.split("=");
        if (chave === "id") {
          id = valor;
          break;
        }
      }
    }

    if (id !== null) {
      this.setState({ avaliacaoId: id });
      axios
        .get(`${API_HOST}/avaliacoes/avaliacao?id=${id}`)
        .then((response) => {
          if (response.data.results[0].nome.includes("PPI")) {
            const tipo_itens = JSON.parse(response.data.results[0].tipo_itens);
            const primeiroTipoItem = tipo_itens != null ? tipo_itens[0] : null;

            this.setState({
              avaliacaoPPI: true,
              areaConhecimentoPPI: response.data.results[0].area_conhecimento,
              periodoPPI: response.data.results[0].periodo,
              cursoPPI: response.data.results[0].curso[0],
              componentePPI: response.data.results[0].componente_curricular,
              tipoItemPPI: primeiroTipoItem
            });



            if (this.state.avaliacaoPPI) {
              const areasConhecimento = Array.isArray(this.state.areaConhecimentoPPI)
                ? this.state.areaConhecimentoPPI
                : [];

              const newInitialValues = {
                ...this.state.initialValues,
                areas_conhecimento: areasConhecimento,
                componente_curricular: this.state.componentePPI,
                tipo: this.state.tipoItemPPI,
                periodo: this.state.periodoPPI,
                curso: this.state.cursoPPI
              };

              formApi.setValues(newInitialValues);
            }
          }
        })
        .catch((error) => {
          console.error("Erro na requisição:", error);
        });
    } else {
      console.error("Parâmetro 'id' não encontrado na URL.");
    }
  };

  getAvaliation = (formApi) => {
    const url = window.location.href;
    const partesDaUrl = url.split("?");
    let id = null;

    if (partesDaUrl.length > 1) {
      const parametros = partesDaUrl[1];
      const paresChaveValor = parametros.split("&");

      for (const par of paresChaveValor) {
        const [chave, valor] = par.split("=");
        if (chave === "id") {
          id = valor;
          break;
        }
      }
    }

    if (id !== null) {
      this.setState({ avaliacaoId: id });
      axios
        .get(`${API_HOST}/avaliacoes/avaliacao?id=${id}`)
        .then((response) => {

          const tipo_itens = JSON.parse(response.data.results[0].tipo_itens);
          const primeiroTipoItem = tipo_itens != null ? tipo_itens[0] : null;
          const areaConhecimento = response.data.results[0].area_conhecimento;

          let resultado;

          if (!isNaN(areaConhecimento)) {

            resultado = [parseInt(areaConhecimento)];
          }
          if (areaConhecimento === "Linguagens, Códigos e suas Tecnologias") {
            resultado = [1];
          } else if (areaConhecimento === "Matemática e suas Tecnologias") {
            resultado = [2];
          } else if (areaConhecimento === "Ciências da Natureza e suas Tecnologias") {
            resultado = [3];
          } else if (areaConhecimento === "Ciências Humanas e suas Tecnologias") {
            resultado = [4];
          } else if (areaConhecimento === "Ensino Religioso") {
            resultado = [5];
          } else if (areaConhecimento === "Educação Tecnológica") {
            resultado = [6];
          }
          if (this.state.avaliacaoId != '') {
            this.setState({

              areaConhecimentoID: resultado,
              periodoID: response.data.results[0].periodo,
              cursoID: response.data.results[0].curso[0],
              componenteID: response.data.results[0].componente_curricular,
              tipoItemID: 1

            });

            const newInitialValues = {
              ...this.state.initialValues,
              areas_conhecimento: this.state.areaConhecimentoID,
              componente_curricular: this.state.componenteID,
              periodo: this.state.periodoID,
              curso: this.state.cursoID,
              tipo: this.state.tipoItemID
            };

            formApi.setValues(newInitialValues);
          }
        }
        )
        .catch((error) => {
          console.error("Erro na requisição:", error);
        });
    } else {
      console.error("Parâmetro 'id' não encontrado na URL.");
    }
  };

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickInfoLearningObject + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickInfoLearningObjectAction,
      label,
    );
  };

  analytcsWrite = (name, type) => {
    let label = "Write" + ": " + name
    let category = ClickInfoLearningObject + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickInfoLearningObjectAction,
      label,
    );
  }

  render() {
    const {
      codigoId,
      tipo,
      area_conhecimento,
      exame,
      instituicao,
      curso,
      anos,
      componente_curricular,
      fetchingData,
      criado_por,
      dificuldade,
      palavras_chave,
      me,
      isLoading = false,
    } = this.state;
    const { isDisabled, breadCrumb } = this.props;

    return (
      <FormContainer
        title={`Informações sobre o ${breadCrumb}`}
        next="matrizes-referencia"
        onClick={this.onSubmit}
        disabled={this.formIsDisabled()}
      >
        <Form
          onChange={(formState) => this.setState({ formState })}
          onValueChange={this.onValueChange}
          getApi={(formApi) => {
            this.formApi = formApi;
            this.getAvaliationPPI(formApi);
            this.getAvaliation(formApi);
          }}
        >
          {({ formApi }) => {
            if (fetchingData) {
              return <Loading />;
            }

            return (
              <React.Fragment>
                {/* {this.renderSaveStatus()} */}
                <div className="row">
                  {this.shouldDisplay('item.exame') && (
                    this.state.avaliacaoPPI ? (
                      <InputSelect
                        disabled={isDisabled}
                        required={this.isRequired('item.exame')}
                        value={2}
                        col="col-sm-6"
                        label="Categoria"
                        field="exame"
                        options={exame}
                        onChange={(value) => {
                          const exameId = get(value, 'value');
                          if (exameId) {
                            this.fetchAreaConhecimento(exameId);
                            this.analytcsClick(`Categoria: ${value.label}`, "InputSelect: Categoria Selected Value");
                          } else {
                            formApi.setValue('areas_conhecimento', []);
                            this.analytcsClick(`Categoria: Excluído`, "InputSelect: Categoria Remove Value");
                          }
                        }}
                      />
                    ) : (
                      <InputSelect
                        disabled={isDisabled}
                        required={this.isRequired('item.exame')}
                        col="col-sm-6"
                        label="Categoria"
                        field="exame"
                        options={exame}
                        onChange={(value) => {
                          const exameId = get(value, 'value');
                          if (exameId) {
                            this.fetchAreaConhecimento(exameId);
                            this.analytcsClick(`Categoria: ${value.label}`, "InputSelect: Categoria Selected Value");
                          } else {
                            formApi.setValue('areas_conhecimento', []);
                            this.analytcsClick(`Categoria: Excluído`, "InputSelect: Categoria Remove Value");
                          }
                        }}
                      />
                    )
                  )}
                  {this.shouldDisplay('item.curso') && (
                    this.state.avaliacaoPPI ? (
                      this.state.avaliacaoId !== '' ? (
                        <InputSelect
                          disabled={isDisabled}
                          value={this.state.cursoPPI}
                          required={this.isRequired('item.curso')}
                          col="col-sm-6"
                          label="Segmento/Etapa"
                          field="curso"
                          options={curso}
                          onChange={(event) => {
                            if (event) {
                              this.analytcsClick(`Segmento/Etapa: ${event.label}`, "InputSelect: Segmento/Etapa Selected Value");
                            }
                            else {
                              this.analytcsClick(`Segmento/Etapa: Excluído`, "InputSelect: Segmento/Etapa Remove Value");
                            }
                            this.setState({
                              cursoPPI: event ? event.value : '',
                              paramsFetch: {
                                ...this.state.paramsFetch,
                                codigoId: event && event.codigo,
                              }
                            })
                          }}
                        />
                      ) : (
                        <InputSelect
                          disabled={isDisabled}
                          required={this.isRequired('item.curso')}
                          value={this.state.cursoID}
                          col="col-sm-6"
                          label="Segmento/Etapa"
                          field="curso"
                          options={curso}
                          onChange={(event) => {
                            if (event) {
                              this.analytcsClick(`Segmento/Etapa: ${event.label}`, "InputSelect: Segmento/Etapa Selected Value");
                            }
                            else {
                              this.analytcsClick(`Segmento/Etapa: Excluído`, "InputSelect: Segmento/Etapa Remove Value");
                            }

                            this.setState({
                              cursoID: event ? event.value : '',
                              paramsFetch: {
                                ...this.state.paramsFetch,
                                codigoId: event && event.codigo,
                              }
                            })
                          }}
                        />
                      )
                    ) : (
                      <InputSelect
                        disabled={isDisabled}
                        required={this.isRequired('item.curso')}
                        col="col-sm-6"
                        label="Segmento/Etapa"
                        field="curso"
                        options={curso}
                        onChange={(event) => {
                          if (event) {
                            this.analytcsClick(`Segmento/Etapa: ${event.label}`, "InputSelect: Segmento/Etapa Selected Value");
                          }
                          else {
                            this.analytcsClick(`Segmento/Etapa: Excluído`, "InputSelect: Segmento/Etapa Remove Value");
                          }
                          this.setState({
                            cursoID: event ? event.value : '',
                            paramsFetch: {
                              ...this.state.paramsFetch,
                              codigoId: event && event.codigo,
                            }
                          })
                        }}
                      />
                    )
                  )}
                  {this.shouldDisplay('item.periodo') && (
                    this.state.avaliacaoPPI ? (
                      this.state.avaliacaoId !== '' ? (
                        <InputSelect
                          disabled={isDisabled}
                          value={this.state.periodoPPI}
                          isLoading={this.state.isLoading}
                          required={this.isRequired('item.periodo')}
                          col="col-sm-6"
                          label="Série/Ano"
                          field="periodo"
                          options={anos}
                          onChange={(value) => {
                            if (value) {
                              this.analytcsClick(`Série/Ano: ${value.label}`, "InputSelect: Série/Ano Selected Value");
                            }
                            else {
                              this.analytcsClick(`Série/Ano: Excluído`, "InputSelect: Série/Ano Remove Value");
                            }
                            this.setState({ periodoPPI: value ? value.value : '' });
                          }}
                        />
                      ) : (
                        <InputSelect
                          disabled={isDisabled}
                          value={this.state.periodoID}
                          isLoading={this.state.isLoading}
                          required={this.isRequired('item.periodo')}
                          col="col-sm-6"
                          label="Série/Ano"
                          field="periodo"
                          options={anos}
                          onChange={(value) => {
                            if (value) {
                              this.analytcsClick(`Série/Ano: ${value.label}`, "InputSelect: Série/Ano Selected Value");
                            }
                            else {
                              this.analytcsClick(`Série/Ano: Excluído`, "InputSelect: Série/Ano Remove Value");
                            }
                            this.setState({ periodoID: value ? value.value : '' });
                          }}
                        />
                      )
                    ) : (
                      <InputSelect
                        disabled={isDisabled}
                        required={this.isRequired('item.periodo')}
                        col="col-sm-6"
                        label="Série/Ano"
                        field="periodo"
                        options={anos}
                        onChange={(value) => {
                          if (value) {
                            this.analytcsClick(`Série/Ano: ${value.label}`, "InputSelect: Série/Ano Selected Value");
                          }
                          else {
                            this.analytcsClick(`Série/Ano: Excluído`, "InputSelect: Série/Ano Remove Value");
                          }
                        }}
                      />
                    )
                  )}
                  {this.shouldDisplay('item.areas_conhecimento') && (
                    this.state.avaliacaoPPI ? (
                      this.state.avaliacaoId !== '' ? (
                        <InputSelect
                          disabled={isDisabled}
                          value={this.state.areaConhecimentoPPI}
                          multi
                          required={this.isRequired('item.areas_conhecimento')}
                          col="col-sm-6"
                          label="Área do conhecimento"
                          field="areas_conhecimento"
                          options={area_conhecimento}
                          onChange={(value) => {
                            if (value) {
                              const name = value.map(option => option.label).join(', ');
                              if (name) {
                                this.analytcsClick(`Área do conhecimento: ${name}`, "InputSelect: Área do conhecimento Selected Value");
                              }
                            }
                            else {
                              this.analytcsClick(`Área do conhecimento: Excluído`, "InputSelect: Área do conhecimento Remove Value");
                            }
                            this.setState({ areaConhecimentoPPI: value ? value.value : '', componentePPI: '' });
                            this.fetchFilterComponenteCurricular(value);
                          }}
                        />
                      ) : (
                        <InputSelect
                          disabled={isDisabled}
                          multi
                          value={this.state.areaConhecimentoID}
                          required={this.isRequired('item.areas_conhecimento')}
                          col="col-sm-6"
                          label="Área do conhecimento"
                          field="areas_conhecimento"
                          options={area_conhecimento}
                          onChange={(value) => {
                            if (value) {
                              const name = value.map(option => option.label).join(', ');
                              if (name) {
                                this.analytcsClick(`Área do conhecimento: ${name}`, "InputSelect: Área do conhecimento Selected Value");
                              }
                            }
                            else {
                              this.analytcsClick(`Área do conhecimento: Excluído`, "InputSelect: Área do conhecimento Remove Value");
                            }
                            this.setState({ areaConhecimentoID: value ? value.value : '', componenteID: '' });
                            this.fetchFilterComponenteCurricular(value);
                          }}
                        />
                      )
                    ) : (
                      <InputSelect
                        disabled={isDisabled}
                        multi
                        required={this.isRequired('item.areas_conhecimento')}
                        col="col-sm-6"
                        label="Área do conhecimento"
                        field="areas_conhecimento"
                        options={area_conhecimento}
                        onChange={(value) => {
                          if (value) {
                            const name = value.map(option => option.label).join(', ');
                            if (name) {
                              this.analytcsClick(`Área do conhecimento: ${name}`, "InputSelect: Área do conhecimento Selected Value");
                            }
                          }
                          else {
                            this.analytcsClick(`Área do conhecimento: Excluído`, "InputSelect: Área do conhecimento Remove Value");
                          }
                          this.fetchFilterComponenteCurricular(value);
                        }}
                      />
                    )
                  )}
                  {(this.state.cursoID == 6 || this.state.cursoID == 10 || this.state.cursoPPI == 6 || this.state.cursoPPI == 10) ? (<></>) : this.shouldDisplay('item.disciplina') && (
                    this.state.avaliacaoPPI ? (
                      this.state.avaliacaoId !== '' ? (
                        <InputSelect
                          disabled={isDisabled}
                          value={this.state.componentePPI}
                          required={this.isRequired('item.disciplina')}
                          col="col-sm-6"
                          label="Componente curricular"
                          field="componente_curricular"
                          options={componente_curricular}
                          onChange={(value) => {
                            if (value) {
                              this.analytcsClick(`Componente curricular: ${value.label}`, "InputSelect: Componente curricular Selected Value");
                            }
                            else {
                              this.analytcsClick(`Componente curricular: Excluído`, "InputSelect: Componente curricular Remove Value");
                            }
                            this.setState({ componentePPI: value ? value.value : '' });
                          }}
                        />
                      ) : (
                        <InputSelect
                          disabled={isDisabled}
                          value={this.state.componenteID}
                          required={this.isRequired('item.disciplina')}
                          col="col-sm-6"
                          label="Componente curricular"
                          field="componente_curricular"
                          options={componente_curricular}
                          onChange={(value) => {
                            if (value) {
                              this.analytcsClick(`Componente curricular: ${value.label}`, "InputSelect: Componente curricular Selected Value");
                            }
                            else {
                              this.analytcsClick(`Componente curricular: Excluído`, "InputSelect: Componente curricular Remove Value");
                            }
                            this.setState({ componenteID: value ? value.value : '' });
                          }}
                        />
                      )
                    ) : (
                      <InputSelect
                        disabled={isDisabled}
                        required={this.isRequired('item.disciplina')}
                        col="col-sm-6"
                        label="Componente curricular"
                        field="componente_curricular"
                        options={componente_curricular}
                        onChange={(value) => {
                          if (value) {
                            this.analytcsClick(`Componente curricular: ${value.label}`, "InputSelect: Componente curricular Selected Value");
                          }
                          else {
                            this.analytcsClick(`Componente curricular: Excluído`, "InputSelect: Componente curricular Remove Value");
                          }
                        }}
                      />
                    )
                  )}
                  {this.shouldDisplay('item.tipo') && (
                    this.state.avaliacaoPPI ? (
                      this.state.avaliacaoId !== '' ? (
                        <InputSelect
                          disabled={isDisabled}
                          value={this.state.tipoItemPPI}
                          required={this.isRequired('item.tipo')}
                          col="col-sm-6"
                          label="Tipo de objeto de aprendizado"
                          field="tipo"
                          options={tipo}
                          onChange={(value) => {
                            if (value) {
                              this.analytcsClick(`Tipo de objeto de aprendizado: ${value.label}`, "InputSelect: Tipo de objeto de aprendizado Selected Value");
                            }
                            else {
                              this.analytcsClick(`Tipo de objeto de aprendizado: Excluído`, "InputSelect: Tipo de objeto de aprendizado Remove Value");
                            }
                            this.setState({ tipoItemPPI: value ? value.value : '' });
                          }}
                        />
                      ) : (
                        <InputSelect
                          disabled={isDisabled}

                          required={this.isRequired('item.tipo')}
                          col="col-sm-6"
                          label="Tipo de objeto de aprendizado"
                          field="tipo"
                          options={tipo}
                          onChange={(value) => {
                            if (value) {
                              this.analytcsClick(`Tipo de objeto de aprendizado: ${value.label}`, "InputSelect: Tipo de objeto de aprendizado Selected Value");
                            }
                            else {
                              this.analytcsClick(`Tipo de objeto de aprendizado: Excluído`, "InputSelect: Tipo de objeto de aprendizado Remove Value");
                            }
                          }}
                        />
                      )
                    ) : (
                      <InputSelect
                        disabled={isDisabled}
                        required={this.isRequired('item.tipo')}
                        col="col-sm-6"
                        label="Tipo de objeto de aprendizado"
                        field="tipo"
                        options={tipo}
                        onChange={(value) => {
                          if (value) {
                            this.analytcsClick(`Tipo de objeto de aprendizado: ${value.label}`, "InputSelect: Tipo de objeto de aprendizado Selected Value");
                          }
                          else {
                            this.analytcsClick(`Tipo de objeto de aprendizado: Excluído`, "InputSelect: Tipo de objeto de aprendizado Remove Value");
                          }
                        }}
                      />
                    )
                  )}
                  {this.shouldDisplay('item.instituicao') && (
                    <InputSelect
                      disabled={isDisabled}
                      required={this.isRequired('item.instituicao')}
                      col="col-sm-6"
                      label="Instituição"
                      field="instituicao"
                      options={instituicao}
                      onChange = {(event)=>{
                        if (event) {
                          this.analytcsClick(`Instituição: ${event.label}`, "InputSelect: Instituição Selected Value");
                        }
                        else {
                          this.analytcsClick(`Instituição: Excluído`, "InputSelect: Instituição Remove Value");
                        }
                      }}
                    />
                  )}
                  {this.shouldDisplay('item.bisserial') && (
                    <InputText
                      disabled={isDisabled}
                      required={this.isRequired('item.bisserial')}
                      col="col-sm-4"
                      label="Bisserial"
                      field="bisserial"
                    />
                  )}
                  {this.shouldDisplay('item.discriminacao') && (
                    <InputText
                      disabled={isDisabled}
                      required={this.isRequired('item.discriminacao')}
                      col="col-sm-4"
                      label="Discriminação"
                      field="discriminacao"
                    />
                  )}
                  {this.shouldDisplay('item.acertos') && (
                    <InputText
                      disabled={isDisabled}
                      required={this.isRequired('item.acertos')}
                      col="col-sm-4"
                      label="Dificuldade"
                      field="acertos"
                    />
                  )}
                  {this.shouldDisplay('item.pa') && (
                    <InputText
                      disabled={isDisabled}
                      required={this.isRequired('item.pa')}
                      col="col-sm-4"
                      label="A"
                      field="pa"
                    />
                  )}
                  {this.shouldDisplay('item.pb') && (
                    <InputText
                      disabled={isDisabled}
                      style={{ color: '#453166' }}
                      required={this.isRequired('item.pb')}
                      col="col-sm-4"
                      label="B"
                      field="pb"
                    />
                  )}
                  {this.shouldDisplay('item.pc') && (
                    <InputText
                      disabled={isDisabled}
                      style={{ color: '#453166' }}
                      required={this.isRequired('item.pc')}
                      col="col-sm-4"
                      label="C"
                      field="pc"
                    />
                  )}
                  {this.shouldDisplay('item.mochila') && (
                    <InputText
                      disabled={isDisabled}
                      style={{ color: '#453166' }}
                      required={this.isRequired('item.mochila')}
                      col="col-sm-4"
                      label="Mochila"
                      field="mochila"
                      onBlur={(event) => {
                        if (event.target.value) {
                          this.analytcsWrite(`Mochila: ${event.target.value}`, "InputText: Mochila Writed Value")
                        }
                        else {
                          this.analytcsWrite(`Mochila: Excluído`, "InputText: Mochila Remove Value")
                        }
                      }}
                    />
                  )}
                  {this.shouldDisplay('item.topico') && (
                    <InputText
                      disabled={isDisabled}
                      style={{ color: '#453166' }}
                      required={this.isRequired('item.topico')}
                      col="col-sm-6"
                      label="Topico"
                      field="topico"
                      onBlur={(event) => {
                        if (event.target.value) {
                          this.analytcsWrite(`Topico: ${event.target.value}`, "InputText: Topico Writed Value")
                        }
                        else {
                          this.analytcsWrite(`Topico: Excluído`, "InputText: Topico Remove Value")
                        }
                      }}
                    />
                  )}
                  {this.shouldDisplay('item.subtopico') && (
                    <InputText
                      disabled={isDisabled}
                      style={{ color: '#453166' }}
                      required={this.isRequired('item.subtopico')}
                      col="col-sm-6"
                      label="SubTopico"
                      field="subtopico"
                      onBlur={(event) => {
                        if (event.target.value) {
                          this.analytcsWrite(`SubTopico: ${event.target.value}`, "InputText: SubTopico Writed Value")
                        }
                        else {
                          this.analytcsWrite(`SubTopico: Excluído`, "InputText: SubTopico Remove Value")
                        }
                      }}
                    />
                  )}
                  {this.shouldDisplay('item.dificuldade') && (
                    <InputSelect
                      disabled={isDisabled}
                      col="col-sm-6"
                      label="Dificuldade presumida"
                      field="dificuldade"
                      options={dificuldade}
                      required={this.isRequired('item.dificuldade')}
                      onChange={(value) => {
                        if (value) {
                          this.analytcsClick(`Dificuldade presumida: ${value.label}`, "InputSelect: Dificuldade presumida Selected Value");
                        }
                        else {
                          this.analytcsClick(`Dificuldade presumida: Excluído`, "InputSelect: Dificuldade presumida Remove Value");
                        }
                      }}
                    />
                  )}
                  {this.shouldDisplay('item.palavras_chave') && (
                    <InputSelectAsyncCreatable
                      disabled={isDisabled}
                      multi
                      col="col-sm-6"
                      label="Palavras-chave"
                      field="palavras_chave"
                      loadOptions={this.fetchPalavrasChave}
                      autoload={false}
                      required={this.isRequired('item.palavras_chave')}
                      onChange = {(value) =>{
                        formApi.setValue('palavras_chave', value);
                        if (value) {
                          const name = value.map(option => option.label).join(', ');
                          if (name) {
                            this.analytcsClick(`Palavras-chave: ${name}`, "InputSelect: Palavras-chave Selected Value");
                          }
                          else{
                            this.analytcsClick(`Palavras-chave: Excluído`, "InputSelect: Palavras-chave Remove Value");
                          }
                        }
                      }}
                    />
                  )}
                </div>
                <label style={{ color: '#453166' }}>
                  <input
                    disabled={isDisabled}

                    name="checkbox_last_item_data"
                    type="checkbox"
                    checked={this.state.usinglastItemData}
                    onChange={this.onChangeUselastItemData}
                    style={{ marginRight: '5px' }}
                  />
                  {`Aproveitar dados do último ${breadCrumb} preenchido`}
                </label>
              </React.Fragment>
            );
          }}
        </Form>
      </FormContainer>
    );
  }
}

export default withRouter(Dados);
